import { render, staticRenderFns } from "./CourierSupplierDetailsTabs.vue?vue&type=template&id=07bd4956&"
import script from "./CourierSupplierDetailsTabs.vue?vue&type=script&lang=js&"
export * from "./CourierSupplierDetailsTabs.vue?vue&type=script&lang=js&"
import style0 from "./CourierSupplierDetailsTabs.vue?vue&type=style&index=0&id=07bd4956&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports